var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.selectedTags),function(tag){return _c('span',{key:tag.id},[_c('disp-single-tag',{attrs:{"label":tag.name,"color":tag.background_color}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }